import { render, staticRenderFns } from "./iconAppearance.vue?vue&type=template&id=6365acb2"
import script from "./iconAppearance.vue?vue&type=script&lang=js"
export * from "./iconAppearance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports